import CONSTANTS from "../../assets/js/Constants";

//reducer gồm các hàm update trạng thái dựa vào kết quả từ api
const general_fuel_report = {};
export default function (state = general_fuel_report, { type, payload }) {
    switch (type) {
        case CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_VEHICLE_GROUPS:
            return { ...state, vehicleGroups: payload };
        case CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_VEHICLES_BY_GROUP:
            return { ...state, vehiclesList: payload };
        case CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_REPORT_EXTEND_DATA_ACTION:
            return { ...state, reportExtendData: payload };
        case CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_DOWNLOAD_EXTEND_REPORT_ACTION:
            return { ...state, downloadExtendReport: payload };
        default: 
            return { ...state };
    }
}